export const getRoute = (state) => state.route.route;